import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { LogDataLegacy, LogDataDistributorLegacy } from '@shared/interface/log.interface';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { UtilitiesService } from '@services/utilities.service';
import { BaseDatasource } from '@shared/base/base.datasource';
import { BaseTableService } from '@shared/base/base-table-service.service';
import { UrlUtilsService } from '@utils/url-utils.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IQueryParams } from '@shared/interface/urlparam.interface';
import { IRetailerRejection } from '@models/retailer.model';

@Component({
  selector: 'app-card-log-legacy',
  templateUrl: './card-log-legacy.component.html',
  styleUrls: ['./card-log-legacy.component.scss'],
})
export class CardLogLegacyComponent implements OnInit {
  @Input() records: LogDataLegacy[];
  @Input() urlDataApi: string;
  @Input() emptyStateText: string = '';

  baseLog: BaseTableService<LogDataLegacy> = this.base;

  baseDatasourceLog: BaseDatasource<LogDataLegacy>;
  string_filter?: string;

  listDataLog: LogDataLegacy[];
  id: string | null = null;
  status: string | null = null;
  tab: string | null = null;

  STRING_CONSTANTS = STRING_CONSTANTS;
  iconNone = STRING_CONSTANTS.ICON.IC_RETAIL_NONE;
  displayedColumns: string[];
  processedDataLog: any[] = [];

  constructor(
    private base: BaseTableService<LogDataLegacy>,
    private paginationService: UrlUtilsService,
    public utilities: UtilitiesService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.id = params.get('id');
      this.status = params.get('status');
      this.tab = params.get('tab');
    });
    this.baseLog.responseDatabase.subscribe((response) => (this.baseDatasourceLog = response));
    this.setTableDataLog();
    this.queryHandler();
    this.initPageInfo();
  }

  setTableDataLog() {
    this.baseDatasourceLog = new BaseDatasource();
    if (this.listDataLog) {
      this.baseDatasourceLog.tableSubject.next(this.listDataLog);
    }
  }

  queryHandler() {
    this.activatedRoute.queryParams.subscribe((data) => {
      this.string_filter = data.string_filter;
      const param = this.paginationService.sliceQueryParams();
      this.baseLog.loadDataTable(this.urlDataApi + this.id, param ? param : '');
    });
  }

  changePageEvent($event: BaseDatasource<any>) {
    const { pageSize, current_page } = $event;
    const dataParam: IQueryParams = {
      page: current_page,
      size: pageSize,
      string_filter: '' || this.string_filter,
    };

    this.router
      .navigate([], {
        queryParams: {
          ...dataParam,
        },
        queryParamsHandling: 'merge',
      })
      .then(() => null);
  }

  initPageInfo() {
    this.baseDatasourceLog.tableSubject.subscribe((data) => {
      if (data) {
        this.processedDataLog = this.generateDataLog(data) ?? [];
        this.listDataLog = data;
      }
    });
  }

  generateDataLog(data: LogDataLegacy[] | LogDataDistributorLegacy[]) {
    if (data.length) {
      const _result: LogDataLegacy[] = [];
      const _descLinkLabel = {
        desc_link: '',
        desc_link_label: 'Lihat Detail',
      };

      const _responseIsDistributor = data.filter((item) => item.hasOwnProperty('distributor_id'));
      if (_responseIsDistributor.length) {
        return this.dataLogMapper(_responseIsDistributor);
      }

      data.map((val) => {
        let _val: LogDataLegacy = val;
        if (val.retailer_status_enum === 'PENDING_EDIT_VERIFICATION') {
          _descLinkLabel.desc_link = `/retailer/detail/${this.status}/active/log/${this.id}`;
          _val = {
            ..._val,
            ..._descLinkLabel,
          };
        }
        _result.push(_val);

        if (val.retailer_status_enum === 'REJECT_EDIT_VERIFICATION') {
          val.reason = [
            {
              desc: '',
              enum_string: 'Informasi retailer tidak sesuai',
              enum_value: '',
            },
            {
              desc: '',
              enum_string: 'Informasi retailer tidak sesuai',
              enum_value: '',
            },
          ];
        }
      });

      // this.listDataLog = _result;
      return _result;
    }
    this.ref.detectChanges();
  }

  generateReason(data: IRetailerRejection[]): string {
    const _result: string[] = [];
    for (let i = 0; i < data.length; i++) {
      _result.push(data[i].enum_string);
    }
    return _result.join(', ');
  }

  dataLogMapper(val: LogDataLegacy[] | LogDataDistributorLegacy[]) {
    const _result: LogDataLegacy[] | LogDataDistributorLegacy[] = [];
    const _descLinkLabel = {
      desc_link: '',
      desc_link_label: 'Lihat Detail',
    };

    if (this.logTypeIsDistributor(val)) {
      const data = val as LogDataDistributorLegacy[];

      data.map((item) => {
        if (item.distributor_id) {
          _descLinkLabel.desc_link = `/distributor/detail/log/${item.distributor_id}`;
          item = {
            ...item,
            ..._descLinkLabel,
            link_param: {
              mode: item.status_enum,
              source: 'log',
            },
          };
        }

        _result.push(item);
      });
    }

    return _result;
  }

  logTypeIsDistributor(data: any): data is LogDataDistributorLegacy {
    const _result = data.filter((item: any) => 'distributor_id' in item).length;
    return !!_result;
  }

  navigateToDetail(link: string, queryParams: any): void {
    if (link) {
      this.router.navigate([link], { queryParams: queryParams, queryParamsHandling: 'merge' }).then();
    } else {
      console.error('Navigation link is undefined or invalid');
    }
  }
}
